// extracted by mini-css-extract-plugin
export default {"container":"IndexParameter-module__container--aSsci","label":"IndexParameter-module__label--ryDez"};